module.exports = __webpack_public_path__ + "static/media/login-bg.eb4e894d.jpg";